module.exports = __webpack_public_path__ + "static/media/bloggerz.e1e14de1.png";